<script>
  import { createEventDispatcher, onMount } from 'svelte';
	import { fade } from 'svelte/transition';
  
  import CompleteIcon from '../../../public/svg/complete-icon.svg';
  import LoaderIcon from '../../../public/svg/loader-icon.svg';
  
  export let image;
  export let files;

  $: isMobile = Math.min(window.screen.width, window.screen.height) < 576;

  const dispatch = createEventDispatcher();

  let isLoadingPreview = false;
  let isShowCompleteIcon = false;

  let imageUrl = '';

  const previewHandler = () => {
    isLoadingPreview = true;
    isShowCompleteIcon = true;
  
    imageUrl = URL.createObjectURL(image);
    
    isLoadingPreview = false;

    setTimeout(() => {
      isShowCompleteIcon = false;
    }, 1500);
  };

  $: getMobileClass = isMobile && Array.from(files).length > 4
    ? 'three-span'
    : 'two-span';

  onMount(previewHandler);
</script>

<!-- превью картинки -->
<div class='wrapper {getMobileClass}'>
  {#if imageUrl}
    <div 
      class="comment-image"
      style:background={`url("${imageUrl}") no-repeat center/contain`}
    />
  {/if}

  <span class='deletButtonPreview' on:click={() => dispatch('delete')}>
    <i class="icon-remove" />
  </span>

  <!-- Показ лоадера при загрузке изображения -->
  <div
    class="preview-skeleton-loader" 
    class:hidden={!isLoadingPreview}
  >
    <LoaderIcon class="loader-icon" />
  </div>

  <!-- Показываем галку, что картинка загрузилась -->
  <!-- Далее прячем -->
  {#if !isLoadingPreview}
    {#if isShowCompleteIcon}
      <div class="complete-layout" transition:fade>
        <CompleteIcon />
      </div>
    {/if}
  {/if}
</div>

<style lang="scss">
  .icon-remove {
    color: white;
  }

  .icon-remove::before {
    margin: 0;
  }

  .comment-image,
  .wrapper {
    margin-right: 6px;
    height: 75px;
    width: 113px;
    border-radius: 5px;
    cursor: pointer;
    background-color: #D6D6D6 !important;
    position: relative;

    @media (max-width: 576px) {

      &.three-span {
        &:first-child,
        &:nth-child(2) {
          grid-column: span 3;  
        }

        grid-column: span 2;
      }

      &.two-span {
        grid-column: span 3;
      }
      
      width: auto;
      height: 80px;
      margin-right: 0;
    }
  }
  
  .deletButtonPreview {
    position: absolute;
    cursor: pointer;
    top: 0;
    right: 3px;
  }

  .complete-layout {
    position: absolute;
    top: 50%; 
    left: 50%; 
    transform: translate(-50%, -50%); 
    display: flex;
    align-items: center;
    justify-content: center;
  }

  .preview-skeleton-loader {
    border: 1px solid #2B50ED;
    width: 100px;
    height: 100px;
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: 4px;
    margin-top: -20px;
  }

  .hidden {
    opacity: 0;
    height: 0;
    width: 0;
  }

  :global(.loader-icon) {
    animation: rotation 1s linear infinite
  }

  @keyframes -global-rotation {
    0% {
        transform: rotate(0deg);
    }
    100% {
        transform: rotate(360deg);
    }
  }
</style>